import React, { useState } from 'react';
import { invitationsAPI } from '../../services/api';
import './InvitePlayerModal.css';

function InvitePlayerModal({ isOpen, onClose, campaignId, campaignName }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      setIsSubmitting(true);
      setError(null);
      
      await invitationsAPI.invitePlayer(campaignId, {
        email: email.trim(),
        message: message.trim()
      });

      setSuccess(true);
      setTimeout(() => {
        onClose();
        // Reset form
        setEmail('');
        setMessage('');
        setSuccess(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to send invitation:', err);
      setError(err?.response?.data?.error || 'Failed to send invitation');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-container invite-modal" role="dialog" aria-modal="true" aria-label="Invite player">
        <div className="modal-header">
          <h3>Invite Player to {campaignName}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {success ? (
            <div className="success-message">
              ✓ Invitation sent successfully!
            </div>
          ) : (
            <>
              <div className="form-field">
                <label htmlFor="playerEmail">Player Email *</label>
                <input
                  id="playerEmail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="player@example.com"
                  required
                  disabled={isSubmitting}
                  autoFocus
                />
                <span className="field-hint">Enter the email address of the player you want to invite</span>
              </div>

              <div className="form-field">
                <label htmlFor="inviteMessage">Personal Message (Optional)</label>
                <textarea
                  id="inviteMessage"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Add a personal message to your invitation..."
                  rows={4}
                  disabled={isSubmitting}
                />
              </div>

              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-primary"
                  disabled={isSubmitting || !email.trim()}
                >
                  {isSubmitting ? 'Sending...' : 'Send Invitation'}
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default InvitePlayerModal;
